$(document).ready(function() {

    $("#ttgOpenDisclaimer").on("click", function(e) {
        e.preventDefault();
        $("#ttgZustimmungsErklaerungTabTheTab").trigger("click");
        $('#ttgDisclaimerContent').modal('hide');
        $("#ttgZustimmungsErklaerungTab").animatescroll();
    });

    // neue TOURDATA Detailseite
    $("#ttgOpenDisclaimerTour").on("click", function(e) {
        e.preventDefault();
        $("#ttgAccZustimmung a").trigger("click");
        $('#ttgDisclaimerContent').modal('hide');
        $("#ttgAccordionZustimmung").animatescroll({
            padding: 110
        });
    });

});